import React from 'react';
import { ArrowRight, Briefcase, Users, Heart, Star, DollarSign } from 'lucide-react';

export default function Careers() {
  const benefits = [
    {
      icon: DollarSign,
      title: "Competitive Compensation",
      description: "Attractive salary packages with performance bonuses and regular reviews"
    },
    {
      icon: Heart,
      title: "Health & Wellness",
      description: "Comprehensive health coverage, dental, and vision insurance"
    },
    {
      icon: Star,
      title: "Professional Growth",
      description: "Training programs, certification support, and career advancement opportunities"
    },
    {
      icon: Users,
      title: "Work-Life Balance",
      description: "Flexible schedules, paid time off, and remote work options"
    }
  ];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80')] opacity-10 bg-cover bg-center"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/50 to-blue-900/90"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold leading-tight mb-6">
              Join Our Team
            </h1>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Be part of a team that's transforming IT services and making a difference in businesses across Texas.
            </p>
            <a
              href="https://www.indeed.com/cmp/Unified-Connexions?from=mobviewjob&tk=1iis9psseg5j9804&fromjk=7f92933e9e2fc853&attributionid=mobvjcmp"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-300 group"
            >
              View Opportunities
              <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Work With Us?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Join a company that values its employees and invests in their growth and well-being
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl opacity-0 group-hover:opacity-5 transition-opacity"></div>
                <div className="relative bg-white rounded-xl shadow-lg p-8 border border-gray-100 h-full transform group-hover:-translate-y-1 transition-all duration-300">
                  <div className="bg-blue-50 p-3 rounded-lg w-fit mb-6 group-hover:scale-110 transition-transform">
                    <benefit.icon className="h-6 w-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Indeed Integration */}
      <div className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100 text-center">
            <img 
              src="https://i.ibb.co/QpjHXgM/UCXLogo.png"
              alt="UCX Indeed Profile"
              className="h-16 mx-auto mb-6"
            />
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Join Our Growing Team</h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Explore our current openings and become part of a company that's dedicated to innovation, growth, and excellence in IT services.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://www.indeed.com/cmp/Unified-Connexions?from=mobviewjob&tk=1iis9psseg5j9804&fromjk=7f92933e9e2fc853&attributionid=mobvjcmp"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                <Briefcase className="mr-2 h-5 w-5" />
                View Open Positions
              </a>
              <a
                href="mailto:careers@ucx.co"
                className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <Briefcase className="mr-2 h-5 w-5" />
                Submit Your Resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}